import styled, { css } from "styled-components";
import { Icon } from "@diana-ui/icon";
import { Body, BodyHighlight } from "@diana-ui/typography";
/**
 * Component text
 */

export var StyledText = /*#__PURE__*/ styled(Body).withConfig({
  displayName: "Notificationstyle__StyledText"
})([""]);
export var TextIcon = /*#__PURE__*/ styled(Icon).withConfig({
  displayName: "Notificationstyle__TextIcon"
})(_ref => {
  var { theme } = _ref;
  return css(["margin-right:", ";"], theme.spaceUnit.sm);
});
export var StyledTitle = /*#__PURE__*/ styled(BodyHighlight).withConfig({
  displayName: "Notificationstyle__StyledTitle"
})([""]);
export var TitleIcon = /*#__PURE__*/ styled(Icon).withConfig({
  displayName: "Notificationstyle__TitleIcon"
})(_ref2 => {
  var { theme } = _ref2;
  return css(["margin-right:", ";"], theme.spaceUnit.sm);
});
export var Wrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Notificationstyle__Wrapper"
})(() =>
  css([
    "display:flex;flex-direction:column;&.enter{opacity:0;transform:translateY(10px);}&.enter-active{opacity:1;transition:opacity 250ms ease-in,transform 125ms ease-in;transform:translateY(10px);}&.exit{opacity:1;transform:translateY(10px);}&.exit-active{opacity:0;transform:translateY(10px);transition:opacity 250ms ease-in,transform 125ms ease-in;}"
  ])
);
export var ContentWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Notificationstyle__ContentWrapper"
})(() => css(["display:flex;align-items:center;"]));
